<template>
	<div class="type-A" v-if="pictureList.length" @mouseenter="stopChange" @mouseleave="startChange">
		<div class="picture-container">
			<img class="single-image" alt="" :src="item" :key="index" :style="imgStyle" v-for="(item, index) in showData.picture" :class="index | setPositionCss(listInfo)">
			<!-- <div class="single-picture" :key="index" :style="item" v-for="(item, index) in pictureList" :class="index | setPositionCss(listInfo)"></div> -->
			<type-grid class="type-A-text" row="1" margin v-if="showData.title || showData.subtitle">
				<type-grid row="1" margin v-if="showData.title">
					<type-title large size="6rem" weight="bold" padding="0">{{ showData.title }}</type-title>
				</type-grid>
				<type-grid row="1" margin v-if="showData.subtitle">
					<type-title medium size="2.4rem" padding="0">{{ showData.subtitle }}</type-title>
				</type-grid>
			</type-grid>
			<type-button round class="action-button" :style="buttonStyle[1]" v-if="showData.is_button" :whitebackdrop="whitebackdrop" @click="jumpAction(showData)">{{ showData.btn_text }}</type-button>
		</div>
		<div class="indicator-container" v-if="showSwiper">
			<ol>
				<li :key="index" @click="changeIndex(index)" v-for="(item, index) in pictureList" :class="curIndex === index ? 'indicator-active' : ''"></li>
			</ol>
		</div>
		<div class="control-left" v-if="showSwiper">
			<span @click="toggleDirec('right')">
				<font-awesome-icon :icon="['fas', 'angle-left']" />
			</span>
		</div>
		<div class="control-right" v-if="showSwiper">
			<span @click="toggleDirec('left')">
				<font-awesome-icon :icon="['fas', 'angle-right']" />
			</span>
		</div>
	</div>
</template>

<script>
    import { fileInfo } from 'util/getPhamula.js'
	// 轮播图(单obj结构框)
	import mixin from '../mixin.js'
	export default {
		name: 'type-A',
		mixins: [ mixin ],
		data() {
			return {
				timer: null,
				curIndex: 0,
				imgStyle: '',
				preIndex: -1,
				direction: ''
			}
		},
		watch: {
			pictureList: {
				handler(newValue) {
					this.containerAdapter();
				},
				immediate: true,
				deep: true
			}
		},
		mounted() {
			this.startChange();
		},
		methods: {
			stopChange() {
				clearInterval(this.timer);
			},
			startChange() {
				if (this.showSwiper) {
					const interval = 4000 + 500;
					this.timer = setInterval(() => {
						this.direction = 'left';
						this.preIndex = this.curIndex;
						this.curIndex = this.getCurIndex();
					}, interval);
				} else {
					this.direction = '';
				}
			},
			getCurIndex() {
				if (this.showSwiper) {
					if (this.direction === 'left') {
						return this.curIndex === (this.pictureList.length - 1) ? 0 : (this.curIndex + 1);
					} else {
						return this.curIndex ? (this.curIndex - 1) : (this.pictureList.length - 1);
					}
				}
				return 0;
			},
			changeIndex(index) {
				if (index != this.curIndex) {
					const specialSpots = [0, this.pictureList.length - 1];
					if (specialSpots.includes(index) && specialSpots.includes(this.curIndex)) {
						this.direction = this.curIndex ? 'left' : 'right';
					} else {
						this.direction = this.curIndex < index ? 'left' : 'right';
					}
					this.preIndex = this.curIndex;
					this.curIndex = index;
				}
			},
			toggleDirec(direction) {
				this.direction = direction;
				this.preIndex = this.curIndex;
				this.curIndex = this.getCurIndex();
			},
			async containerAdapter() {
				if (this.pictureList.length) {
					let height = 0; // 2:3
					const sizeList = [];
					// 取图片高度最小的那张作为轮播图的高度显示
					for (let src of (this.showData.picture || [])) {
						let result = await fileInfo(src, 'image');
						if (result.status === 'success') {
							sizeList.push({
								src,
								width: result.width,
								height: result.height
							});
						}
					}
					const baseWidth = document.body.offsetWidth;
					for (let p of sizeList) {
						p['baseWidth'] = baseWidth;
						p['baseHeight'] = Math.round(p.height * baseWidth / p.width);
						if (height === 0) {
							height = p['baseHeight'];
						} else {
							height = height < p['baseHeight'] ? height : p['baseHeight'];
						}
					}
					height = height || Math.round(baseWidth / 3 * 2); // 2:3
					this.imgStyle = `width: 100%;height: ${height}px;font-size: 0;object-fit: cover;object-positon: 50% 50%;`;
					// console.log(sizeList.map(item => item.baseHeight), baseWidth, height, this.imgStyle)
				}
			}
		},
		filters: {
			setPositionCss(index, listInfo) {
				const { length, curIndex, preIndex, direction } = listInfo;
				if (length === 1 || direction === '') {
					return index ? 'picture-wait' : 'picture-init';
				}
				if (index === curIndex) {
					return direction === 'left' ? 'left-in' : 'right-in';
				}
				if (index === preIndex) {
					return direction === 'left' ? 'left-out' : 'right-out';
				}
				return 'picture-wait';
			}
		},
		computed: {
			pictureList() {
				return (this.showData.picture || []).map(v => `background-image: url(${v});`) || [];
			},
			showSwiper() {
				return this.pictureList.length > 1;
			},
			listInfo() {
				return {
					length: this.pictureList,
					curIndex: this.curIndex,
					preIndex: this.preIndex,
					direction: this.direction
				};
			}
		},
        beforeDestroy() {
			this.stopChange();
			this.curIndex = 0;
			this.preIndex = -1;
			this.direction = '';
		}
	}
</script>

<style scoped lang="less">
	.type-A, .picture-container, .single-picture{
		width: 100%;
	}
	.type-A{
		position: relative;
		.picture-container{
			position: relative;
			overflow: hidden;
			.type-A-text{
				position: absolute;
				color: #FFFFFF;
				z-index: 10;
				left: 50%;
				top: 50%;
				margin: 0 !important;
				pointer-events: none;
				text-shadow: 2px 2px 20px #000000;
				transform: translate(-50%, -50%);
			}
			.action-button{
				position: absolute;
				z-index: 10;
			}
			.single-image{
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
			}
			.single-picture{
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				background-position: center center;
				background-repeat: no-repeat;
				background-size: cover;
			}
			.picture-init{
				left: 0;
				z-index: 1;
			}
			.picture-wait{
				left: 100%;
				z-index: -1;
			}
			.left-in{
				animation: left-in 500ms linear forwards;
			}
			.left-out{
				animation: left-out 500ms linear forwards;
			}
			.right-in{
				animation: right-in 500ms linear forwards;
			}
			.right-out{
				animation: right-out 500ms linear forwards;
			}
			@keyframes left-in{
				from{
					left: 100%;
				}
				to{
					left: 0;
				}
			}
			@keyframes left-out{
				from{
					left: 0;
				}
				to{
					left: -100%;
				}
			}
			@keyframes right-in{
				from{
					left: -100%;
				}
				to{
					left: 0;
				}
			}
			@keyframes right-out{
				from{
					left: 0;
				}
				to{
					left: 100%;
				}
			}
		}
		.indicator-container{
			position: absolute;
			left: 50%;
			z-index: 3;
			width: 60%;
			padding-left: 0;
			margin-left: -30%;
			ol{
				list-style: none;
				text-align: center;
				li{
					display: inline-block;
					width: 10px;
					height: 10px;
					cursor: pointer;
					margin: 1px 3px;
					text-indent: -999px;
					border-radius: 10px;
					border: 1px solid #FFFFFF;
					background-color: rgba(0, 0, 0, 0);
					&.indicator-active{
						width: 12px;
						height: 12px;
						background-color: #FFFFFF;
					}
				}
			}
		}
		.control-left, .control-right{
			width: 15%;
			height: 100%;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			top: 0;
			bottom: 0;
			z-index: 2;
			span{
				color: #FFFFFF;
				font-weight: 400;
				text-shadow: 0 1px 2px rgba(0, 0 ,0, 0.6);
				background-color: rgba(0, 0, 0, 0);
				filter: alpha(opacity=50);
				opacity: .5;
				width: 30px;
				height: 30px;
				font-size: 30px;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			&:hover{
				span{
					opacity: 0.9;
				}
			}
		}
		.control-left{
			left: 0;
		}
		.control-right{
			right: 0;
		}
	}
	@media screen and (min-width: 720px){
		.type-A, .picture-container, .single-picture{
			height: calc(100vw / 16 * 9);
		}
		.indicator-container{
			bottom: 20px;
		}
		.action-button{
			bottom: 50px;
            right: 80px;
		}
	}
	@media screen and (max-width: 719px){
		.type-A, .picture-container, .single-picture{
			height: calc(100vw / 16 * 9);
		}
		.indicator-container{
			bottom: 15px;
		}
		.action-button{
			bottom: 40px;
            right: 25px;
		}
	}
</style>